import { render, staticRenderFns } from "./SchoolTransactionsPage.vue?vue&type=template&id=9872fa02&lang=pug&"
import script from "./SchoolTransactionsPage.vue?vue&type=script&lang=js&"
export * from "./SchoolTransactionsPage.vue?vue&type=script&lang=js&"
import style0 from "./SchoolTransactionsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports